module.exports = __webpack_public_path__ + "img/outsideWx.2c2d0914.png";